export default __webpack_public_path__ + "ca34d9d041e4f374aab94222654b8c9a.jpg";